<template>
  <div>
    <!-- chart js  -->
    <div class="py-4 container-fluid">
      <!-- chart js -->
      <div class="row">
        <div
          v-for="(item, index) in data.filter(
            (item) => item.show == true && item.output_cpu
          )"
          :key="index"
          class="col-lg-2 text-center"
        >
          <Chart :chartId="index" :item="item" />
        </div>
      </div>
      <!-- chart js -->
    </div>
    <div class="py-4 container-fluid">
      <div class="row">
        <!-- Payment Method -->
        <div class="col-6 text-end">
          <div v-if="showPaymentMethod" id="myModal" class="modal_class">
            <div class="modal-content invoice">
              <span @click="popup_close" class="close">&times;</span>

              <h5 class="text-center">Please Select Payment Method</h5>

              <div class="my-3 mx-12 text-center">
                <p v-if="pay_loading">Loading ..</p>
                <span
                  v-if="pay_loading"
                  class="spinner-border spinner-border-sm mx-3"
                ></span>
                <span v-else @click="getPay()" class="cursor-pointer"
                  ><img src="../assets/img/logos/bkash.svg" style="width: 200px"
                /></span>
              </div>
              <div class="flex text-center"></div>
            </div>
          </div>
        </div>
        <!--Month List Popup -->
        <div v-if="showPopup" id="myModal" class="modal_class">
          <div class="modal-content dark-modeon">
            <span @click="popup_close" class="close text-end">&times;</span>

            <div class="my-3 mx-12 mx-auto">
              <default-info-card
                class="cursor-pointer"
                icon="text-white fas fa-shopping-cart"
                :title="pact_data.olt_packge_list[0].name"
                :port_count="pact_data.olt_packge_list[0].port_count"
                :olt_modes="pact_data.olt_packge_list[0].olt_modes_id"
                :value="
                  'Tk ' +
                  (firstIntegerValue
                    ? firstIntegerValue * pact_data.olt_packge_list[0].price
                    : pact_data.olt_packge_list[0].price)
                "
                :expeire_at="
                  firstIntegerValue
                    ? formatDate(
                        new Date(
                          new Date().setMonth(
                            new Date().getMonth() + firstIntegerValue
                          )
                        )
                      )
                    : null
                "
              />
              <select
                v-model="selected_month"
                name=""
                id=""
                class="form-control mt-3 text-black font-bold text-center bg-white"
              >
                <option value="" disabled selected hidden>Select Month</option>
                <option
                  v-for="(item, index) in month_data"
                  :key="index"
                  :value="index"
                >
                  {{ item }}
                </option>
              </select>
            </div>
            <div class="flex text-center">
              <div class="grid grid-cols-2 gap-2">
                <button class="btn btn-secondary mx-3" @click="popup_close">
                  Cancel
                </button>
                <button class="btn btn-success" @click="Pay(selected_month)">
                  Pay Now
                  <span
                    v-if="loading_pay_now"
                    class="spinner-border spinner-border-sm mx-3"
                  ></span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- ############### -->
        <!-- #### card #### -->
        <!-- ############# -->
        <div class="roles_ mb-4">
          <!-- #1 -->

          <div class="_card" :key="item">
            <div class="header">
              <p
                class="m-0 p-0"
                style="font-weight: 400; font-size: 14px !important"
              >
                Number of OLT
              </p>
            </div>
            <p class="m-0 p-0 font-weight-bold" style="font-size: 24px">{{filteredData.length}}</p>
          </div>

          <!-- #3 -->

          <div class="_card" :key="item">
            <div class="header">
              <p
                class="m-0 p-0"
                style="font-weight: 400; font-size: 14px !important"
              >
                Active OLT
              </p>
            </div>
            <p class="m-0 p-0 font-weight-bold" style="font-size: 24px"> {{ filteredData.filter(item => item.new_status === 'open').length }}</p>
          </div>

          <!-- #4 -->

          <div class="_card" :key="item">
            <div class="header">
              <p
                class="m-0 p-0"
                style="font-weight: 400; font-size: 14px !important"
              >
                Offline OLT
              </p>
            </div>
            <p class="m-0 p-0 font-weight-bold" style="font-size: 24px">{{filteredData.filter(item => item.new_status == 'closed').length}}</p>
          </div>
        </div>

        <div class="col-12 mt-4">
          <div class="card invoice">
            <!-- Card header -->
            <div class="pb-0 card-header invoice">
              <div
                class="d-lg-flex justify-content-between align-items-center mx-3"
              >
                <div class="">
                  <h5>
                    Olt List <span class="badge">{{ filteredData.length }}</span>
                  </h5>
                </div>
                <div class="d-flex gap-2">
                  <div class="flex-grow-1">
                    <input
                      type="text"
                      v-model="searchQuery"
                      class="form-control invoice"
                      placeholder="Search..."
                    />
                  </div>
                  <div class="flex-grow-1">
                    <select
                      v-model="branchFilter"
                      class="form-control invoice dark-filter"
                      placeholder="Filter by Branch"
                    >
                      <option value="" >All Branches</option>
                      <option
                        v-for="(branch, index) in uniqueBranches"
                        :key="index"
                        :value="branch"
                      >
                        {{ branch }}
                      </option>
                    </select>
                  </div>
                  <div class="">
                    <router-link :to="{ name: 'AddOlt' }">
                      <button
                        class="bg-success btn text-white rounded py-0"
                        :style="{
                          height: '35px',
                        }"
                      >
                        Add New
                      </button>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="table-responsive"
              v-if="filteredData && filteredData.length > 0"
            >
              <div class="card mb-4">
                <div class="card-body px-0 pt-0 pb-2 invoice">
                  <div class="table-responsive p-0">
                    <table class="table align-items-center mb-0">
                      <thead>
                        <tr>
                          <!-- ### olt ip #### -->
                          <th
                            @click="sort('olt_ip')"
                            :class="{
                              asc: sortKey === 'olt_ip' && sortOrder === 'asc',
                              desc: sortKey === 'olt_ip' && sortOrder === 'desc',
                            }"
                            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                          >
                            OLT IP
                            <span class="sort-icon"> </span>
                          </th>

                          <!-- ### olt name #### -->

                          <th
                            @click="sort('olt_name')"
                            :class="{
                              asc: sortKey === 'olt_name' && sortOrder === 'asc',
                              desc:
                                sortKey === 'olt_name' && sortOrder === 'desc',
                            }"
                            class="text-secondary text-xxs font-weight-bolder opacity-7"
                          >
                            Olt Name
                            <span class="sort-icon"> </span>
                          </th>
                          <th
                            @click="sort('Branch_olt_name')"
                            :class="{
                              asc: sortKey === 'Branch_olt_name' && sortOrder === 'asc',
                              desc:
                                sortKey === 'Branch_olt_name' && sortOrder === 'desc',
                            }"
                            class="text-secondary text-xxs font-weight-bolder opacity-7"
                          >
                            Branch Name
                            <span class="sort-icon"> </span>
                          </th>

                          <!-- ### olt id #### -->
                          <th
                            @click="sort('oltid')"
                            :class="{
                              asc: sortKey === 'oltid' && sortOrder === 'asc',
                              desc: sortKey === 'oltid' && sortOrder === 'desc',
                            }"
                            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                          >
                            Olt ID
                            <span class="sort-icon"> </span>
                          </th>

                          <!-- ###     Mikrotik IP  #### -->
                          <th
                            @click="sort('Mikrotik_ip')"
                            :class="{
                              asc:
                                sortKey === 'Mikrotik_ip' && sortOrder === 'asc',
                              desc:
                                sortKey === 'Mikrotik_ip' && sortOrder === 'desc',
                            }"
                            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                          >
                            Mikrotik IP
                            <span class="sort-icon"> </span>
                          </th>

                          <!-- ###status#### -->

                          <th
                            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                          >
                            Status
                            <span class="sort-icon"> </span>
                          </th>

                          <!-- ### actions #### -->
                          <th
                            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                          >
                            Action
                            <span class="sort-icon"> </span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(data, index) in filteredData" :key="index" :class="{ 'row-red-bg': data.color_status === false }">
                          <!-- ### olt ip #### -->

                          <td
                            :class="{ 'text-danger': !data.show }"
                            class="align-middle"
                          >
                            <p class="text-xs font-weight-bold mb-0">
                              {{ data.olt_ip }}
                            </p>
                          </td>

                          <!-- ### olt name #### -->
                          <td
                            :class="{ 'text-danger': !data.show }"
                            class="align-middle"
                          >
                            <p class="text-xs font-weight-bold mb-0">
                              {{ data.olt_name }}
                            </p>
                          </td>
                          <td
                            :class="{ 'text-danger': !data.show }"
                            class="align-middle"
                          >
                            <p class="text-xs font-weight-bold mb-0">
                              {{ data?.Branch_olt_oltlist }}
                            </p>
                          </td>

                          <!-- ### olt id #### -->
                          <td :class="{ 'text-danger': !data.show }">
                            <p class="text-xs font-weight-bold mb-0">
                              {{ data.oltid }}
                            </p>
                          </td>

                          <!-- ###     Mikrotik IP  #### -->
                          <td
                            :class="{ 'text-danger': !data.show }"
                            class="align-middle text-sm"
                          >
                            <p class="text-xs font-weight-bold mb-0">
                              {{ data.Mikrotik_ip }}
                            </p>
                          </td>

                          <!-- ###status#### -->
                          <td class="align-middle">
                            <soft-badge
                              v-if="data.new_status == 'closed'"
                              class="bg-danger px-2 rounded-1 text-white"
                              variant="gradient"
                              size="sm"
                              style="font-size: 12px !important"
                              >Offline
                            </soft-badge>

                            <soft-badge
                              v-if="data.new_status == 'open'"
                              class="btn-success px-2 rounded-1 text-white"
                              variant="gradient"
                              size="sm"
                              style="font-size: 12px !important"
                              >Online
                            </soft-badge>
                          </td>

                          <!-- #### actions###### -->
                          <td class="align-middle">
                            <div
                              class="d-flex align-items-center"
                              style="gap: 20px"
                            >
                              <router-link
                                class="dark-filter"
                                :to="{
                                  name: 'OltDetails',
                                  params: { id: data.oltid },
                                }"
                              >
                                <span class="text-sm me-1 _view">View </span>
                              </router-link>
                              <template v-if="hasPermission('2023')">
                              <i
                                @click="handleEdit(data.id)"
                                class="fas fa-edit cursor-pointer"
                              ></i>
                              <!-- Reset icon for color_status false -->
                              <i
                                v-if="data.color_status === false"
                                @click="handleOltReset(data.olt_code)"
                                class="fas fa-sync-alt text-warning cursor-pointer"
                                title="Reset OLT"
                                style="margin-left: 10px;"
                              ></i>
                              <i
                                @click="handleDelete(data.id)"
                                class="fas fa-trash text-danger cursor-pointer"
                              ></i>                              
                              </template>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- #####paginations####### -->
                  <div class="pagination-container">
                    <button
                      class="btn btn-sm btn-success mx-3 mt-3"
                      @click="previousPage"
                      :disabled="currentPage === 1"
                    >
                      Previous
                    </button>
                    <span class="mx-2"
                      >Page {{ currentPage }} of {{ totalPages }}</span
                    >
                    <button
                      class="btn btn-sm btn-success mx-3 mt-3"
                      @click="nextPage"
                      :disabled="currentPage === totalPages"
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <Skalaton />
            </div>
          </div>
        </div>
      </div>
      <div class="col-6 text-end" v-if="delete_olt_popup">
        <div class="popup_bg"></div>
        <div id="myModal" class="modal_class">
          <div class="modal-content invoice p-4 shadow-lg rounded">
            <div class="d-flex justify-content-center align-items-center mb-3">
              <h5 class="text-center m-0">Are you sure?</h5>
            </div>
            <div class="text-center">
              <button @click="delete_olt_data()" class="btn btn-danger w-40 mx-1">
                Yes, delete it!
              </button>
              <button @click="popup_close" class="btn btn-success w-40 mx-1">
                No, keep it
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DefaultInfoCard from "@/examples/Cards/DefaultInfoCard.vue";
import dataList from "../services/data_list.service";
import deleteOlt from "../services/delete_olt.service";
import getPortStatusCheck from "../services/check-ports-status.service";
import Chart from "@/components/Chart.vue";
import MonthList from "../services/get-month-list.service";
import FasterPayBill from "../services/faster-pay-bill.service";
import PayBillByPacID from "../services/get-pack-name-with-olt-id.service";
import showSwal from "../mixins/showSwal.js";
import Skalaton from "@/components/Skalaton.vue";
import { hasPermission } from "@/utils/permissions.js";
import { useOltDetailsApi } from "../services/olt_details.service";

export default {
  name: "Olt List",
  components: {
    Skalaton,
    DefaultInfoCard,
    Chart,
  },
  data() {
    return {
      sortKey: "",
      sortOrder: "asc",
      data: [],
      pact_data: [],
      filteredData: [],
      month_data: [],
      selected_month: "",
      selected_id: null,
      searchQuery: "",
      branchFilter: "", // New property for branch filtering
      currentPage: 1,
      selectedId: "",
      itemsPerPage: 20,
      showPopup: false,
      bkashURL: "",
      pay_loading: false,
      delete_olt_popup: false,
      loading_pay_now: false,
      showPaymentMethod: false,
      portStatus: null,
    };
  },

  async mounted() {
    await this.getData();
    await this.getMonthData();
  },
  methods: {
    hasPermission,
    handleEdit(id) {
      if (!this.hasPermission("2024")) {
        showSwal.methods.showSwal({
          type: "error",
          message: "You do not have permission to perform this action.",
        });
        return;
      }
      this.$router.push({ name: "EditOlt", params: { edit_id: id } });
    },
    async handleDelete(id) {
      if (!this.hasPermission("2024")) {
        showSwal.methods.showSwal({
          type: "error",
          message: "You do not have permission to perform this action.",
        });
        return;
      }
      this.selectedId = id;
      this.delete_olt_popup = true;
    },
    async delete_olt_data() {
      await deleteOlt.deleteOlt(this.selectedId);
      showSwal.methods.showSwal({
        type: "success",
        message: "Data deleted successfully!",
      });
      this.getData();
      this.popup_close();
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    async Pay(selected_month) {
      this.loading_pay_now = true;
      if (selected_month == "") {
        showSwal.methods.showSwal({
          type: "error",
          message: "Please Select a Month",
        });
      }
      const response = await FasterPayBill.PayBill(
        selected_month,
        this.selected_id
      );
      this.loading_pay_now = false;
      if (response.bkashURL) {
        this.bkashURL = response.bkashURL;
        this.showPaymentMethod = true;
        this.showPopup = false;
      } else {
        showSwal.methods.showSwal({
          type: "error",
          message: "Something is wrong",
        });
      }
    },

    async getPay() {
      this.pay_loading = true;
      if (this.bkashURL) {
        window.open(this.bkashURL);
      }
      this.showPaymentMethod = false;
      this.pay_loading = false;
    },

    popup_close() {
      this.showPopup = false;
      this.delete_olt_popup = false;
      this.selectedId = '';
      this.showPaymentMethod = false;
      (this.selected_item = []),
        (this.selected_id = null),
        (this.selected_month = ""),
        (this.pact_data = []);
    },
    async open_popup(id) {
      this.pact_data = await PayBillByPacID.PayBillByPacID(id);
      this.showPopup = true;
      this.selected_id = id;
    },
    async getMonthData() {
      const response = await MonthList.getMonthListData();
      this.month_data = response;
    },
    async getData() {
      const response = await dataList.getDataList();
      this.data = response;

      for (let item of this.data) {
        // Merge the new field
        item.olt_code = `${item.servicefname}_${item.oltid}`;

        const olt_ip = item.olt_ip;
        const olt_port = item.olt_port;
        const Mikrotik_ip = item.Mikrotik_ip;
        const m_port = item.m_port;

        const response = await getPortStatusCheck.getPortStatusCheck(
          olt_ip,
          olt_port,
          Mikrotik_ip,
          m_port
        );

        item.new_status = response.status;
        const response3 = await useOltDetailsApi().oltStatus(item.olt_code)

        item.color_status = response3.active;
      }

      this.filteredData = this.data;
    },
    sort(key) {
      if (this.sortKey === key) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        this.sortKey = key;
        this.sortOrder = "asc";
      }

      this.filteredData.sort((a, b) => {
        const valueA = a[key] ? a[key].toString().toLowerCase() : "";
        const valueB = b[key] ? b[key].toString().toLowerCase() : "";
        const comparison = valueA.localeCompare(valueB);
        return this.sortOrder === "asc" ? comparison : -comparison;
      });
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    async handleOltReset(olt_code) {
      try {
        await useOltDetailsApi().oltReset(olt_code);
        showSwal.methods.showSwal({
          type: 'success',
          message: 'OLT reset successfully!'
        });
        // Optionally refresh data
        await this.getData();
      } catch (error) {
        showSwal.methods.showSwal({
          type: 'error',
          message: 'Failed to reset OLT.'
        });
      }
    },
  },
  computed: {
    totalPages() {
      return Math.ceil(this.filteredData.length / this.itemsPerPage);
    },
    paginatedData() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      return this.filteredData.slice(
        startIndex,
        startIndex + this.itemsPerPage
      );
    },
    firstIntegerValue() {
      const match = this.selected_month.match(/\d+/);
      return match ? parseInt(match[0]) : null;
    },
    uniqueBranches() {
      return [...new Set(this.data.map((item) => item?.Branch_olt_oltlist))];
    },
  },
  watch: {
    searchQuery(newValue) {
      this.filteredData = this.data.filter((item) => {
        const matchesSearchQuery = Object.keys(item).some((key) =>
          String(item[key]).toLowerCase().includes(newValue.toLowerCase())
        );
        const matchesBranchFilter = this.branchFilter
          ? item?.Branch_olt_oltlist?.toLowerCase().includes(this.branchFilter.toLowerCase())
          : true;
        return matchesSearchQuery && matchesBranchFilter;
      });
      this.currentPage = 1;
    },
    branchFilter(newValue) {
      this.filteredData = this.data.filter((item) => {
        const matchesSearchQuery = Object.keys(item).some((key) =>
          String(item[key]).toLowerCase().includes(this.searchQuery.toLowerCase())
        );
        const matchesBranchFilter = newValue
          ? item?.Branch_olt_oltlist?.toLowerCase().includes(newValue.toLowerCase())
          : true;
        return matchesSearchQuery && matchesBranchFilter;
      });
      this.currentPage = 1;
    },
  },
};
</script>

<style>
/* The Modal (background) */
.modal_class {
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #aaaaaa;
}

/* Modal Content/Box */
.modal-content {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 50%;
  padding: 20px;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

/* Close Button */
.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}

td {
  padding: 12px 24px !important;
}

.sort-icon {
  margin-left: 5px;
}

.asc::after {
  content: "▲";
}

.desc::after {
  content: "▼";
}

.badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: bold;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 50%;
  background-color: #40c133;
  /* or any other color you prefer */
  color: #fff;
  /* text color */
}

/* ###################
#####################
 */
.roles_ {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-top: 30px;
}

._card {
  border-radius: 10px;
  padding: 20px;
  color: rgba(0, 0, 0, 0.589);
  display: flex;
  flex-direction: column;
  gap: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.dark-mode ._card {
  background-color: #061f3e;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
._view {
  font-weight: 600 !important;
}

._view:hover {
  color: #40c133 !important;
  transition-duration: 300ms;
  text-decoration: underline;
}

.row-red-bg {
  background-color: #825b5a !important; /* Material Red 600 */
  color: #fff !important;
}
.row-red-bg td,
.row-red-bg th {
  color: #fff !important;
}
</style>